<template>
  <ResponsiveTable style="margin-bottom: 0; max-width: 500px;">
    <!-- TODO: think about adding below-field error message & error state indication (e.g. red border) [DSP-N26CxI4P] -->

    <!-- Stream Type -->
    <Cell class="flex" :width="`8rem`">
      <LabelCustomized label="Stream Type" />
    </Cell>
    <Cell class="flex items-center" :width="`20rem`">
      <SelectField
        style="width: 100%"
        :options="streamTypeOptions"
        v-model="streamType"
        label-key="label"
        value-key="name"
      />
    </Cell>
  
    <!-- Stream URL -->
    <Cell class="flex" :width="`8rem`">
      <LabelCustomized label="Stream URL" />
    </Cell>
    <Cell class="flex items-center" :width="`20rem`">
      <TextField
        name="streamUrl"
        v-model="streamUrl"
        required
        class="field"
        width="40ch"
      />
    </Cell>
  
    <template v-if="streamType !== 'webpage'">
      <!-- Start Time -->
      <Cell class="flex" :width="`8rem`">
        <LabelCustomized label="Start Time" />
      </Cell>
      <Cell class="flex items-center" :width="`20rem`">
        <DateField v-model="startDate" disabled width="100%" class="mr-2" />
        <TimeField v-model="startTime" disabled width="100%" step=1 />
      </Cell>
    
      <!-- End Time -->
      <Cell class="flex" :width="`8rem`">
        <LabelCustomized label="End Time" />
      </Cell>
      <Cell class="flex items-center" :width="`20rem`">
        <DateField v-model="endDate" width="100%" class="mr-2" />
        <TimeField v-model="endTime" width="100%" step=1 />
      </Cell>
    
      <!-- Stream Duration -->
      <Cell class="flex" :width="`8rem`">
        <LabelCustomized label="Stream Duration" />
      </Cell>
      <Cell class="flex items-center" :width="`20rem`">
        {{ streamDuration }}
      </Cell>
    </template>
  </ResponsiveTable>
</template>


<script setup lang="ts">
import TextField from "@/components/form-fields/TextField.vue";
import SelectField from "@/components/form-fields/SelectField/SelectField.vue";
import DateField from "@/components/form-fields/DateField.vue";
import TimeField from "@/components/form-fields/TimeField.vue";
import LabelCustomized from '@/components/form-fields/LabelCustomized/LabelCustomized.vue';
import { ResponsiveTable, Cell}  from '@/components/ResponsiveTable';
import sharedRefs from './sharedRefs';

import { useLiveStream } from "./composables/liveStream";
import { computed, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
})
const emit = defineEmits(['update:modelValue']);

const {
  streamTypeOptions,
  bindingOptionsInitialValues,
  getStreamDuration
} = useLiveStream()

const streamType = ref(props.modelValue.streamType || bindingOptionsInitialValues.streamType);
const streamUrl = ref(props.modelValue.streamUrl || bindingOptionsInitialValues.streamUrl);
const startDate = ref(props.modelValue.startDate || bindingOptionsInitialValues.startDate);
const startTime = ref(props.modelValue.startTime || bindingOptionsInitialValues.startTime);
const endDate = ref(props.modelValue.endDate || bindingOptionsInitialValues.endDate);
const endTime = ref(props.modelValue.endTime || bindingOptionsInitialValues.endTime);
const { isStartStream } = sharedRefs;
isStartStream.value = props.modelValue.isStartStream || bindingOptionsInitialValues.isStartStream;

const streamDuration = computed(() => getStreamDuration(
  startDate.value,
  startTime.value,
  endDate.value,
  endTime.value
));

// Preparing Binding Data
const bindingOptions = computed(() => {
  return {
    id: props.modelValue.id,
    streamType: streamType.value,
    streamUrl: streamUrl.value,
    startDate: startDate.value,
    startTime: startTime.value,
    endTime: endTime.value,
    endDate: endDate.value,
    isStartStream: isStartStream.value,
  }
});

watch([
  streamType,
  streamUrl,
  startDate,
  startTime,
  endDate,
  endTime,
  isStartStream
], () => {
  emit('update:modelValue', bindingOptions.value)
})
</script>

<style lang="scss" scoped>

</style>
